import React from 'react';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { EnvPullCommand } from '../components/EnvPullCommand/index.js';
import type { ProjectModel } from '../model.js';
import { log } from './logger.js';
import { executeCommand } from './execute-command.js';

export async function nonInteractiveEnvPull(
  services: AstroCommandServices,
  model: ProjectModel
) {
  await executeCommand(services, model, () => <EnvPullCommand />);

  log(JSON.stringify({ success: true }, null, 2));
}
